import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-content-header-button',
  templateUrl: './content-header-button.component.html',
  styleUrls: ['./content-header-button.component.scss']
})
export class ContentHeaderButtonComponent implements OnInit {
  @Input() name: string;
  @Input() visible: boolean;
  @Input() disabled: boolean;
  @Input() icon: string;
  @Input() color: string;
  @Input() id: string;
  @Input() type: 'raised' | 'normal' | 'flat' = 'normal';
  @Output() buttonClick = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}
}
